import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../../stores/auth.store'

interface PermissionGuardProps {
  required: 'admin' | 'authenticated'
  children: ReactNode
}

export function PermissionGuard({ required, children }: PermissionGuardProps) {
  const user = useAuthStore((s) => s.user)

  if (!user) return <Navigate to="/login" replace />

  if (required === 'admin' && !user.is_tenant_admin) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
